import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrimaryListButtonData } from '../../models/primary-list-button-data';

@Component({
  selector: 'app-primary-list-button',
  templateUrl: './primary-list-button.component.html',
  styleUrls: ['./primary-list-button.component.less'],
})
export class PrimaryListButtonComponent implements OnInit {
  @Input() buttonSize = 'normal';
  @Input() colNum = 2;
  @Input() text = '';
  @Input() data: PrimaryListButtonData[] = [];
  @Input() disabled;

  @Output() callButtonClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
  }

  onButtonClick(event) {
    this.callButtonClick.emit(event);
  }
}
